export const hasTaxes = (country, state) => {
  let hasTaxes = false
  const search = `${country.toLowerCase().trim()}-${state.toLowerCase().trim()}`

  switch (search) {
    case 'united states-new york':
    case 'united states-ny':
    case 'united states-nevada':
    case 'united states-nv':
    case 'united states-tennessee':
    case 'united states-tn':
    case 'canada-alberta':
    case 'canada-ab':
    case 'canada-british columbia':
    case 'canada-britishcolumbia':
    case 'canada-bc':
    case 'canada-manitoba':
    case 'canada-mb':
    case 'canada-new brunswick':
    case 'canada-newbrunswick':
    case 'canada-newfoundland and labrador':
    case 'canada-newfoundlandandlabrador':
    case 'canada-northwest territories':
    case 'canada-northwestterritories':
    case 'canada-nova scotia':
    case 'canada-novascotia':
    case 'canada-ns':
    case 'canada-nunavut':
    case 'canada-nu':
    case 'canada-ontario':
    case 'canada-on':
    case 'canada-prince edward island':
    case 'canada-princeedwardisland':
    case 'canada-pe':
    case 'canada-quebec':
    case 'canada-qc':
    case 'canada-québec':
    case 'canada-saskatchewan':
    case 'canada-sk':
    case 'canada-yukon':
    case 'canada-yt':
      hasTaxes = true
      break
    default:
      hasTaxes = false
      break
  }

  return hasTaxes
}
